export default {
  name: 'marking--importHImport',
  apiService: 'shoes',
  apiPath: '/admin/import_h/func/upload',
  urlParamName: 'marking--importHImport',
};
